// src/shared/stockQty.js — „налични: 12 бр." при избора на артикул от
// каталога (Макс, 20.10.2026: „когато избирам артикул, да ми пише
// количество при избора"). Ползват го фактурата и проформата.
//
// stock — наличностите, заредени от /stock/balances ({ article_id → ред }),
// или null, ако не са заредени / складът е изключен; тогава нищо не пише.
// Складов артикул без ред в наличностите има 0 — и това се казва, за да не
// се продаде нещо, което го няма.

import { stockTypes } from '../../services/stock.js';

const fq = (n) => String(Math.round((Number(n) || 0) * 10000) / 10000).replace('.', ',');

export function stockQtyText(a, stock, mode) {
  if (!stock || !a || !stockTypes(mode).includes(a.type)) return '';
  const b = stock[a.id];
  return 'налични: ' + fq(b ? b.qty : 0) + ' ' + ((b && b.measure) || a.measure || '');
}
